import { NgModule } from '@angular/core';
import { ICSLoaderComponent } from './loader.component';

@NgModule({
  imports: [
  ],
  declarations: [ICSLoaderComponent],
  exports: [ICSLoaderComponent]
})
export class ICSLoaderModule { }
